import React from 'react';

const NotificationTableHead = () => {
  return (
    <thead className="thead-light table-light">
      <tr className="align-middle text-uppercase text-muted font-weight-semibold" style={{ fontSize: '14px' }}>
        <th style={{ width: '5%' }} className="text-center">#</th>
        <th style={{ width: '12%' }} className="text-center">Category</th>
        <th style={{ width: '12%' }} className="text-center">Priority</th>
        <th style={{ width: '23%' }} className="text-center">Date &amp; Time</th>
        <th style={{ width: '20%' }} className="text-center">Vessel</th>
        <th style={{ width: '28%' }} className="text-start ps-3">Title</th>
      </tr>
    </thead>
  );
};

export default NotificationTableHead;
